export default "__VITE_ASSET__C_ksSVTt__"